import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  metrics: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    highlight: PropTypes.bool,
  })).isRequired,
}

const MetricsShowcase = ({ title, description, metrics }) => {
  return (
    <styles.Container>
      <styles.Header>
        <styles.Title>{title}</styles.Title>
        {description && <styles.Description>{description}</styles.Description>}
      </styles.Header>
      
      <styles.MetricsGrid>
        {metrics.map((metric, index) => (
          <styles.MetricCard key={index} highlight={metric.highlight}>
            {metric.icon && (
              <styles.MetricIcon>
                <img src={metric.icon} alt={`${metric.label} icon`} />
              </styles.MetricIcon>
            )}
            <styles.MetricValue highlight={metric.highlight}>
              {metric.value}
            </styles.MetricValue>
            <styles.MetricLabel>{metric.label}</styles.MetricLabel>
          </styles.MetricCard>
        ))}
      </styles.MetricsGrid>
    </styles.Container>
  )
}

MetricsShowcase.propTypes = propTypes

export default MetricsShowcase